(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["colette-buybox"] && !Shopify.designMode) return;
  try {
    
  // Size finder: weight picks the band from the size table ("40 – 50 kg", upper bound
  // inclusive), height nudges it near the band edges, and the usual clothing size can
  // only push it up.
  document.querySelectorAll('[data-cc-sizefinder]').forEach((finder) => {
    const table = finder.parentElement.querySelector('table');
    const weight = finder.querySelector('[data-cc-weight]');
    const height = finder.querySelector('[data-cc-height]');
    const usual = finder.querySelector('[data-cc-usual]');
    const result = finder.querySelector('[data-cc-result]');
    const rows = [...(table?.querySelectorAll('tbody tr') || [])]
      .map((row) => {
        const cells = [...row.cells].map((c) => c.textContent);
        const kg = (cells[cells.length - 1].match(/\d+/g) || []).map(Number);
        const fr = (cells[1]?.match(/\d+/g) || []).map(Number);
        return { size: cells[0].trim(), min: kg.length === 1 ? 1 : kg[0], max: kg.length === 1 ? kg[0] : kg[1], frMax: fr[1] };
      })
      .filter((r) => r.min && r.max);
    const contact = () => {
      result.hidden = false;
      result.textContent = `Au-delà de ${rows[rows.length - 1].max} kg, écrivez-nous à ${finder.dataset.email} : nous vous conseillons personnellement.`;
    };
    const find = () => {
      const kg = Number(weight.value);
      const cm = Number(height.value);
      if (!kg || !rows.length) return;
      if (kg > rows[rows.length - 1].max) return contact();
      let index = rows.findIndex((r, i) => (i === 0 ? kg >= r.min : kg > r.min) && kg <= r.max);
      if (index === -1) index = 0;
      const band = rows[index];
      let note = '';
      if (cm >= 172 && band.max - kg <= 3) index += 1;
      else if (cm && cm <= 155 && kg - band.min <= 3 && index > 0) note = ' ou la taille en dessous si vous aimez près du corps';
      if (usual.value) {
        const fromUsual = rows.findIndex((r) => r.frMax >= Number(usual.value));
        if (fromUsual === -1) return contact();
        if (fromUsual > index) { index = fromUsual; note = ''; }
      }
      if (index >= rows.length) return contact();
      result.hidden = false;
      result.innerHTML = `Nous vous conseillons la taille <strong>${rows[index].size}</strong>${note}.`;
    };
    finder.querySelector('[data-cc-find]').addEventListener('click', find);
    finder.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches('input')) { event.preventDefault(); find(); }
    });
  });

  document.querySelectorAll('[data-cc-gallery]').forEach((gallery) => {
    const main = gallery.querySelector('[data-cc-main]');
    // Swipe left/right on the main photo to move through the thumbnails.
    let startX = null;
    main?.addEventListener('touchstart', (event) => { startX = event.touches[0].clientX; }, { passive: true });
    main?.addEventListener('touchend', (event) => {
      if (startX === null) return;
      const dx = event.changedTouches[0].clientX - startX;
      startX = null;
      if (Math.abs(dx) < 40) return;
      const thumbs = [...gallery.querySelectorAll('.cc-buybox__thumb')];
      const current = thumbs.findIndex((t) => t.classList.contains('is-active'));
      const next = thumbs[(current + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length];
      next?.click();
    });
    gallery.querySelectorAll('.cc-buybox__thumb').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (!main) return;
        main.removeAttribute('srcset');
        main.src = thumb.dataset.src;
        gallery.querySelectorAll('.cc-buybox__thumb').forEach((t) => t.classList.toggle('is-active', t === thumb));
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colette-countdown"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cc-countdown]').forEach((bar) => {
    const end = Number(bar.dataset.end) * 1000;
    const pad = (n) => String(n).padStart(2, '0');
    const tick = () => {
      const left = end - Date.now();
      if (left <= 0) {
        const fallback = bar.querySelector('[data-fallback]');
        if (!fallback.textContent.trim()) return bar.remove();
        bar.querySelectorAll('.cc-countdown__label, .cc-countdown__time').forEach((el) => (el.hidden = el !== fallback));
        bar.querySelectorAll('.cc-countdown__label--short').forEach((el) => el.remove());
        fallback.hidden = false;
        return;
      }
      const s = Math.floor(left / 1000);
      const days = Math.floor(s / 86400);
      bar.querySelector('[data-d]').textContent = pad(days);
      bar.querySelector('[data-days]').hidden = days === 0;
      bar.querySelector('[data-h]').textContent = pad(Math.floor((s % 86400) / 3600));
      bar.querySelector('[data-m]').textContent = pad(Math.floor((s % 3600) / 60));
      bar.querySelector('[data-s]').textContent = pad(s % 60);
      setTimeout(tick, 1000);
    };
    tick();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colette-hero"] && !Shopify.designMode) return;
  try {
    
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll('[data-cc-hero-video]').forEach((video) => {
      video.removeAttribute('autoplay');
      video.pause();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colette-size-page"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-cc-sp-finder]').forEach((finder) => {
    const table = finder.closest('.cc-sp')?.querySelector('[data-cc-sp-table]');
    const weight = finder.querySelector('[data-cc-weight]');
    const height = finder.querySelector('[data-cc-height]');
    const usual = finder.querySelector('[data-cc-usual]');
    const result = finder.querySelector('[data-cc-result]');
    const rows = [...(table?.querySelectorAll('tbody tr') || [])]
      .map((row) => {
        const cells = [...row.cells].map((c) => c.textContent);
        const kg = (cells[cells.length - 1].match(/\d+/g) || []).map(Number);
        const fr = (cells[1]?.match(/\d+/g) || []).map(Number);
        return { size: cells[0].trim(), min: kg.length === 1 ? 1 : kg[0], max: kg.length === 1 ? kg[0] : kg[1], frMax: fr[1] };
      })
      .filter((r) => r.min && r.max);
    const contact = () => {
      result.hidden = false;
      result.textContent = `Au-delà de ${rows[rows.length - 1].max} kg, écrivez-nous à ${finder.dataset.email} : nous vous conseillons personnellement.`;
    };
    const find = () => {
      const kg = Number(weight.value);
      const cm = Number(height.value);
      if (!kg || !rows.length) return;
      if (kg > rows[rows.length - 1].max) return contact();
      let index = rows.findIndex((r, i) => (i === 0 ? kg >= r.min : kg > r.min) && kg <= r.max);
      if (index === -1) index = 0;
      const band = rows[index];
      let note = '';
      if (cm >= 172 && band.max - kg <= 3) index += 1;
      else if (cm && cm <= 155 && kg - band.min <= 3 && index > 0) note = ' ou la taille en dessous si vous aimez près du corps';
      if (usual.value) {
        const fromUsual = rows.findIndex((r) => r.frMax >= Number(usual.value));
        if (fromUsual === -1) return contact();
        if (fromUsual > index) { index = fromUsual; note = ''; }
      }
      if (index >= rows.length) return contact();
      result.hidden = false;
      result.innerHTML = `Nous vous conseillons la taille <strong>${rows[index].size}</strong>${note}.`;
    };
    finder.querySelector('[data-cc-find]').addEventListener('click', find);
    finder.addEventListener('keydown', (event) => {
      if (event.key === 'Enter' && event.target.matches('input')) { event.preventDefault(); find(); }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colette-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  // Shows the bar once the hero (homepage) or the buy box (product page) has been
  // scrolled past, and hides it whenever the buy box is on screen.
  document.querySelectorAll('[data-cc-sticky]').forEach((bar) => {
    const offer = document.getElementById('offre');
    if (!offer || !('IntersectionObserver' in window)) return;
    const hero = document.querySelector('.cc-hero');
    const trigger = hero && hero.compareDocumentPosition(offer) & Node.DOCUMENT_POSITION_FOLLOWING ? hero : offer;
    bar.hidden = false;
    let passed = false;
    let offerVisible = false;
    const render = () => bar.classList.toggle('is-visible', passed && !offerVisible);
    new IntersectionObserver(([entry]) => {
      passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      render();
    }).observe(trigger);
    if (trigger !== offer) {
      new IntersectionObserver(([entry]) => {
        offerVisible = entry.isIntersecting;
        render();
      }).observe(offer);
    } else {
      offerVisible = false;
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["colette-video-reviews"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.cc-vids').forEach((root) => {
    const track = root.querySelector('[data-cc-track]');
    const step = () => (track.querySelector('.cc-vid')?.offsetWidth || 230) + 14;
    root.querySelector('[data-cc-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    root.querySelector('[data-cc-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
